export default "__VITE_ASSET__BFMVr$5Z__"